import { ReactNode } from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import { i18nProps } from 'Types';
import { ORDER_STATUS } from '../../../../__queries__/globalTypes';

type Props = (
  order: {
    status: ORDER_STATUS;
    estimatedFinishTime: string;
    easyId: string;
  },
  i18n: i18nProps,
  locale: string,
) => {
  statusText: string;
  messageText: string | ReactNode;
};
const getTexts: Props = (order, i18n, locale) => {
  const { status, easyId, estimatedFinishTime } = order;
  const orderStatus = status.toLowerCase();

  dayjs.extend(relativeTime);
  const timeLeftTo = dayjs(estimatedFinishTime || undefined)
    .locale(locale)
    .fromNow(true);
  switch (orderStatus) {
    case 'pending':
      return {
        statusText: i18n('Orderstatus.Pending.Title'),
        messageText: i18n('Orderstatus.Pending.Text'),
      };
    case 'accepted':
    case 'finalizing':
      return {
        statusText: i18n('Orderstatus.Preparing.Title'),
        messageText: (
          <>
            {i18n('Orderstatus.Preparing.Text')} <b>{timeLeftTo}</b>
          </>
        ),
      };
    case 'ready':
      return {
        statusText: i18n('Orderstatus.Ready.Title'),
        messageText: (
          <>
            {i18n('Orderstatus.Ready.Text.I')} <b>{easyId}</b> {i18n('OrderStatus.Ready.Text.II')}
          </>
        ),
      };
    case 'rejected':
      return {
        statusText: i18n('Order.Status.Rejected'),
        messageText: <>{i18n('OrderStatus.Rejected.Text')}</>,
      };
    default:
      return {
        statusText: '',
        messageText: '',
      };
  }
};

export default getTexts;
